import * as XLSX from "xlsx";

const SHEET_NAME = "Products";
const FILENAME = "outward_products_template.xlsx";

const HEADERS = [
  "productSKU",
  "productCode",
  "productName",
  "productDescription",
  "dispatchQuantity",
  "allocationMethod",
  "batchNumber",
  "batchQuantity",
];

/**
 * Download Excel template for outward create product table.
 * @param {Array<{ _id: string, sku: string, productCode?: string, skuName?: string, description?: string }>} products - all products (rows in template)
 */
export function downloadOutwardProductsTemplate(products = []) {
  const rows = [
    HEADERS,
    ...products.map((p) => [
      p.sku || "",
      p.productCode ?? p.sku ?? "",
      p.skuName || p.description || "",
      p.description || "",
      "",
      "FEFO",
      "",
      "",
    ]),
  ];
  const ws = XLSX.utils.aoa_to_sheet(rows);
  ws["!cols"] = [
    { wch: 18 },
    { wch: 18 },
    { wch: 28 },
    { wch: 32 },
    { wch: 16 },
    { wch: 18 },
    { wch: 24 },
    { wch: 16 },
  ];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, SHEET_NAME);
  const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const blob = new Blob([wbout], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = FILENAME;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
